import { render, staticRenderFns } from "./CustomerOrdersList.vue?vue&type=template&id=02920b48&scoped=true&"
import script from "./CustomerOrdersList.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrdersList.vue?vue&type=style&index=0&id=02920b48&lang=scss&scoped=true&"
import style1 from "./CustomerOrdersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02920b48",
  null
  
)

export default component.exports